module.exports = __webpack_public_path__ + "img/googleplay.b0df194a.svg";